import { atom } from 'recoil';

const calculatorStyleState = atom({
  key: 'calculatorStyleState',
  default: {},
});

export default calculatorStyleState;
